<script setup>
import { computed, watch } from 'vue';
import { useApiSlugs } from '@/composables/useApiSlugs';
import { useCmsPage } from '@/composables/useCmsPage';

import { useBlocks } from '@/composables/useBlocks';
import { useSeo } from '@/composables/useSeo';
import AosContainer from '@/components/AosContainer.vue';

import Breadcrumbs from '@/components/ui/Breadcrumbs.vue';
const { getPageSlug } = useApiSlugs();
const blockComponents = useBlocks();
const apiSlug = computed(() => getPageSlug());

const { data } = await useCmsPage(apiSlug);
const isRedirect = computed(() => !!data.value?.redirect?.redirect_url);
const seoInput = computed(() => {
  const pageData = data.value?.data;
  if (!data.value?.success || isRedirect.value || !pageData) return null;

  return {
    title: pageData.seo_title || pageData.title || '',
    description: pageData.meta_description || '',
    keywords: pageData.meta_keywords || '',
    robots: pageData.meta_robots || 'index, follow',
    image: pageData.image_cover?.src || null,
    path: pageData.url || '',
  };
});

useSeo({
  title: computed(() => seoInput.value?.title),
  description: computed(() => seoInput.value?.description),
  keywords: computed(() => seoInput.value?.keywords),
  robots: computed(() => seoInput.value?.robots),
  image: computed(() => seoInput.value?.image),
  path: computed(() => seoInput.value?.path),
});
const isUkravtoGroupPage = computed(() => {
  if (!data.value?.data) return false;
  const pageData = data.value?.data;
  const currentUrl = pageData?.url || '';
  const breadcrumbs = pageData?.breadcrumbs?.items || [];

  const hasGroupInUrl =
    typeof currentUrl === 'string' && currentUrl.includes('ukravto-group');

  const hasGroupInBreadcrumbs =
    Array.isArray(breadcrumbs) &&
    breadcrumbs.some((item) => item.url === '/ukravto-group');

  return hasGroupInUrl || hasGroupInBreadcrumbs;
});
</script>

<template>
  <AosContainer
    v-if="data?.success && !isRedirect"
    :options="{ once: true, duration: 600, easing: 'ease-out' }"
  >
    <Breadcrumbs
      v-if="data?.data?.breadcrumbs?.items"
      :breadcrumbs="data?.data?.breadcrumbs?.items"
    />
    <div class="page-dynamic">
      <component
        :is="blockComponents[block.type]"
        v-for="(block, index) in data?.data?.sections"
        :id="block.id"
        :key="block.id"
        :data="block.data"
        :page-type="data?.data?.url"
        :is-ukravtogroup="isUkravtoGroupPage"
        :is-first-section="index === 0"
      />
    </div>
  </AosContainer>
</template>
